import { Text, Tooltip } from '@shared/components';
import { VoiceContribution } from '@shared/types/conversation';
import {
  TranscriptSegment,
  transcriptSegments,
} from '../../utils/transcriptSegments';

type VoiceContributionTranscriptProps = {
  contribution: VoiceContribution;
};
export const VoiceContributionTranscript = ({
  contribution,
}: VoiceContributionTranscriptProps) => {
  const segments = transcriptSegments(contribution.transcript);
  return (
    <span className="whitespace-pre-wrap">
      <Text type="body-xs">
        {segments.map((segment, index) => (
          <SegmentComponent key={index} segment={segment} />
        ))}
      </Text>
    </span>
  );
};

function SegmentComponent({ segment }: { segment: TranscriptSegment }) {
  if (!segment.isLowConfidence) return <span>{segment.text}</span>;
  return <LowConfidenceSegmentComponent segment={segment} />;
}

function LowConfidenceSegmentComponent({
  segment,
}: {
  segment: Extract<TranscriptSegment, { isLowConfidence: true }>;
}) {
  return (
    <Tooltip
      content={`"${segment.text}" (${(segment.confidence * 100).toFixed(0)}%)`}
    >
      <span className="opacity-50 blur-[0.5px]">{segment.text}</span>
    </Tooltip>
  );
}
